export const DIMENSION_FONT_SIZE = 1.8;
export const DIMENSION_LABEL_X_PADDING_FACTOR = 0.25;
export const DIMENSION_LABEL_Y_PADDING_FACTOR = 0;
export const DIMENSION_LABEL_BASELINE_PADDING = 0;

export const DIMENSION_STROKE_WIDTH = 0.1875;

export const DIMENSION_CENTER_LINE_INITIAL_Y = 4;
export const DIMENSION_CENTER_LINE_PADDING_TOP = 0.5;

export const DIMENSION_CENTER_LINE_OVAL_STROKE_WIDTH = 0.2;

export const DIMENSION_HALF_LINE_TERMINATOR = 0.8;

export const DIMENSION_OUTSIDE_LINE_OFFSET_X = 3;
export const DIMENSION_OUTSIDE_LINE_OFFSET_Y = 3;

export const DIMENSION_OUTSIDE_TEXT_POSITION_FACTOR_X = 0.5;
export const DIMENSION_OUTSIDE_TEXT_POSITION_FACTOR_Y = 0.5;
export const DIMENSION_OUTSIDE_LINE_FACTOR_X = 0.75;
export const DIMENSION_OUTSIDE_LINE_FACTOR_Y = 0.5;

export const DIMENSION_INSIDE_TEXT_POSITION_FACTOR_X = 0.25;
export const DIMENSION_INSIDE_TEXT_POSITION_FACTOR_Y = 0.15;
export const DIMENSION_INSIDE_LINE_FACTOR_X = 0.15;
export const DIMENSION_INSIDE_LINE_FACTOR_Y = 0.66;

export const DIMENSION_MINUMUM_VERTICAL_BEFORE_OFFSETTING_LABEL = 2.5;
export const DIMENSION_VERTICAL_LABEL_OFFSET = 1;
